import _sfc_main from "./MasterApplyControlH5.vue2.mjs";
/* empty css                           */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "apply-control-container" }, [_setup.applyToAnchorUserCount ? _c("div", { staticClass: "apply-list-mobile" }, _vm._l(_setup.applyToAnchorList, function(item) {
    return _c("div", { key: item.userId, staticClass: "apply-item" }, [_c("div", { staticClass: "user-info" }, [_c(_setup.Avatar, { staticClass: "avatar-url", attrs: { "img-src": item.avatarUrl } }), _c("div", { staticClass: "stage-info" }, [_c("span", { staticClass: "user-name", attrs: { "title": _setup.roomService.getDisplayName(item) } }, [_vm._v(_vm._s(_setup.roomService.getDisplayName(item)))]), _c("span", { staticClass: "apply-tip" }, [_vm._v(_vm._s(_setup.t("Apply for the stage")))])])], 1), _c("div", { staticClass: "control-container" }, [_c("div", { staticClass: "reject-button", on: { "click": function($event) {
      return _setup.handleUserApply(item.userId, false);
    } } }, [_vm._v(" " + _vm._s(_setup.t("Reject")) + " ")]), _c("div", { staticClass: "agree-button", on: { "click": function($event) {
      return _setup.handleUserApply(item.userId, true);
    } } }, [_vm._v(" " + _vm._s(_setup.t("Agree")) + " ")])])]);
  }), 0) : _c("div", { staticClass: "apply-control-nobody" }, [_c(_setup.SvgIcon, { attrs: { "icon": _setup.ApplyStageLabelIcon } }), _c("span", { staticClass: "apply-text" }, [_vm._v(_vm._s(_setup.t("Currently no member has applied to go on stage")))])], 1), _c("div", { staticClass: "apply-list-footer" }, [_c("div", { staticClass: "action-button", class: { disabled: _setup.applyToAnchorUserCount === 0 }, on: { "click": function($event) {
    return _setup.handleAllUserApply(false);
  } } }, [_vm._v(" " + _vm._s(_setup.t("Reject All")) + " ")]), _c("div", { staticClass: "action-button agree", class: { disabled: _setup.applyToAnchorUserCount === 0 }, on: { "click": function($event) {
    return _setup.handleAllUserApply(true);
  } } }, [_vm._v(" " + _vm._s(_setup.t("Agree All")) + " ")])])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "ee314078"
);
const MasterApplyControlH5 = __component__.exports;
export {
  MasterApplyControlH5 as default
};
